<template>
  <v-col :cols="cols" class="metric-card">
    <v-card dark color="rgba(255, 255, 255, 0.1)" class="pa-3 rounded-lg fill-height d-flex flex-column justify-center align-center tiktok-card">
      <v-icon large :color="iconColor" class="mb-2">{{ icon }}</v-icon>
      <div class="text-h6 font-weight-bold">{{ formattedValue }}</div>
      <div style="color: white !important" class="caption text--secondary">{{ labelText }}</div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "MetricCard",
  props: {
    value: { type: [Number, String], required: true },
    unit: { type: String, default: "" },
    label: { type: String, default: "" },
    icon: { type: String, default: "mdi-chart-bar" },
    iconColor: { type: String, default: "white" },
    cols: { type: [Number, String], default: 4 },
  },
  computed: {
    formattedValue() {
      const num = parseFloat(this.value)
      if (isNaN(num)) return this.value
      return num % 1 === 0 ? num.toFixed(0) : num.toFixed(1)
    },
    labelText() {
      return this.label || (this.unit ? this.unit : "")
    },
  },
}
</script>

<style scoped>
.metric-card {
  text-align: center;
}
.tiktok-card {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
</style>
